import * as ACTIONS from "../actions";

import Api from "../../services";

import cm from "./CommonFunction";

const Documents = {
  state: {
    Docsloading: false,
    DocsErrorMessage: null,
    ConfirmLoading: false,
    ConfirmError: null,
    //PhysicalDeliveryLoading: false,
    //PhysicalDeliveryError: null
  },
  getters: {
    DOCSLOADING: (state) => state.Docsloading,
    DOCSERRORMESSAGE: (state) => state.DocsErrorMessage,
    GETCONFIRMLOADING: (state) => state.ConfirmLoading,
    GETCONFIRMERROR: (state) => state.ConfirmError,
    //GETPHYSICALDELIVERYLOADING: state => state.PhysicalDeliveryLoading,
    //GETPHYSICALDELIVERYERROR: state => state.PhysicalDeliveryError
  },
  actions: {
    [ACTIONS.DOWNLOAD_DOCUMENT]: (context, query) => {
      context.commit(ACTIONS.DOWNLOAD_DOCUMENT_PENDING);

      return new Promise((resolve, reject) => {
        Api.get("Documents" + query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
          responseType: "arraybuffer",
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.DOWNLOAD_DOCUMENT_SUCCESS,
              ACTIONS.DOWNLOAD_DOCUMENT_ERROR,
              false,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.DOWNLOAD_DOCUMENT_ERROR);
            return reject(err);
          });
      });
    },
    [ACTIONS.CANCEL_COMPLETED_TRANSACTION]: (context, query) => {
      context.commit(ACTIONS.CANCEL_COMPLETED_TRANSACTION_PENDING);
      var url = "";
      try {
        url = query.get("URL");
        query.delete("URL");
      } catch (errs) {}

      if (url == null || url == "") {
        url = "CancelCompletedRequest";
      }
      return new Promise((resolve, reject) => {
        Api.post("Request/" + url, query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.CANCEL_COMPLETED_TRANSACTION_SUCCESS,
              ACTIONS.CANCEL_COMPLETED_TRANSACTION_ERROR,
              true,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(
              context,
              err,
              ACTIONS.CANCEL_COMPLETED_TRANSACTION_ERROR,
            );
            return reject(err);
          });
      });
    },
    [ACTIONS.REMOVE_OWNER]: (context, query) => {
      context.commit(ACTIONS.REMOVE_OWNER_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Request/" + query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.REMOVE_OWNER_SUCCESS,
              ACTIONS.REMOVE_OWNER_ERROR,
              false,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.REMOVE_OWNER_ERROR);
            return reject(err);
          });
      });
    },
    [ACTIONS.PHYSICAL_DELIVERY]: (context, query) => {
      context.commit(ACTIONS.PHYSICAL_DELIVERY_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Request/" + query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.PHYSICAL_DELIVERY_SUCCESS,
              ACTIONS.PHYSICAL_DELIVERY_ERROR,
              false,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.PHYSICAL_DELIVERY_ERROR);
            return reject(err);
          });
      });
    },
  },
  mutations: {
    [ACTIONS.DOWNLOAD_DOCUMENT_ERROR]: (state, msg) => {
      state.DocsErrorMessage = msg;
      state.Docsloading = false;
    },
    [ACTIONS.DOWNLOAD_DOCUMENT_PENDING]: (state) => {
      state.DocsErrorMessage = null;
      state.Docsloading = true;
    },
    [ACTIONS.DOWNLOAD_DOCUMENT_SUCCESS]: (state) => {
      state.DocsErrorMessage = null;
      state.Docsloading = false;
    },
    [ACTIONS.CANCEL_COMPLETED_TRANSACTION_PENDING]: (state) => {
      state.ConfirmError = null;
      state.ConfirmLoading = true;
    },
    [ACTIONS.CANCEL_COMPLETED_TRANSACTION_SUCCESS]: (state) => {
      state.ConfirmError = null;
      state.ConfirmLoading = false;
    },
    [ACTIONS.CANCEL_COMPLETED_TRANSACTION_ERROR]: (state, msg) => {
      state.ConfirmError = msg;
      state.ConfirmLoading = false;
    },
    [ACTIONS.REMOVE_OWNER_PENDING]: (state) => {
      state.ConfirmError = null;
      state.ConfirmLoading = true;
    },
    [ACTIONS.REMOVE_OWNER_SUCCESS]: (state) => {
      state.ConfirmError = null;
      state.ConfirmLoading = false;
    },
    [ACTIONS.REMOVE_OWNER_ERROR]: (state, msg) => {
      state.ConfirmError = msg;
      state.ConfirmLoading = false;
    },
    [ACTIONS.PHYSICAL_DELIVERY_PENDING]: (state) => {
      state.DocsErrorMessage = null;
      state.Docsloading = true;
    },
    [ACTIONS.PHYSICAL_DELIVERY_SUCCESS]: (state) => {
      state.DocsErrorMessage = null;
      state.Docsloading = false;
    },
    [ACTIONS.PHYSICAL_DELIVERY_ERROR]: (state, msg) => {
      state.DocsErrorMessage = msg;
      state.Docsloading = false;
    },
  },
};

const commit = {
  success: function(
    context,
    res,
    SuccessAction,
    ErrorAction,
    saveData = false,
  ) {
    var { commit } = context;

    if (res && res.status == 200) {
      var { data } = res;

      if (data && data.StatusCode) {
        if (data.StatusCode == 200) {
          commit(SuccessAction);
        } else if (
          data &&
          (data.StatusCode == 500 ||
            data.StatusCode == 403 ||
            data.StatusCode == 2 ||
            data.StatusCode == 429 ||
            data.StatusCode == 1 ||
            data.StatusCode == 406 ||
            data.StatusCode == 0)
        ) {
          commit(ErrorAction, data.StatusMessage);
        }
      } else {
        commit(SuccessAction);
      }
    } else if (res.status == 500) {
      commit(ErrorAction, data.StatusMessage);
    } else if (res.status == 403) {
      commit(ErrorAction, "Error 403: Access Denied");
    } else if (res.status == 403) {
      commit(ErrorAction, "Error 406: Not Acceptable");
    } else {
      commit(ErrorAction, "Unknown Error");
    }
  },
  Error: function(context, err, ActionName) {
    var { commit } = context;
    if (err.response) {
      commit(ActionName, "Error " + err.status);
    }
    if (err.request) {
      commit(ActionName, err.message);
    } else {
      // Something happened in setting up the request that triggered an Error

      commit(ActionName, "Error " + err.message);
    }
  },
};
export default Documents;
